$(function () {
    var $bell = $('#fetch_notifications');
    var $container = $('#admin-notifications');
    var $headerSubtitle = $('.notification-message');
    var $badge = $bell.find('.badge');
    var $bellIcon = $bell.find('.fa-bell');
    var $bellBg = $bell.find('.icon-wrapper-bg');
    var lastUnreadCount = 0;
    var lastUnreadByType = {};
    var lastNotificationsJson = '';
    var hasInteracted = false;
    var shownCustomIds = {};
    var notificationsById = {};
    var notifSound = new Audio('/sounds/notification.mp3');
    notifSound.preload = 'auto';
    var STORAGE_KEY = 'notif_last_count';
    var STORAGE_TYPES_KEY = 'notif_unread_by_type';
    var SIDEBAR_BADGES = {
        IntakeRegistrationSubmitted: $('#sidebar-intake-unread'),
        TicketDueReminder: $('#sidebar-ticket-unread'),
    };

    if (!$bell.length) return;

    lastUnreadCount = parseInt(localStorage.getItem(STORAGE_KEY), 10) || 0;
    lastUnreadByType = parseStoredTypes(localStorage.getItem(STORAGE_TYPES_KEY));
    applyCounts(lastUnreadCount, lastUnreadByType);
    requestNotificationPermission();

    $(document).on('click', function () {
        hasInteracted = true;
    });

    window.addEventListener('storage', function (e) {
        if (e.key === STORAGE_KEY) {
            lastUnreadCount = parseInt(e.newValue, 10) || 0;
            updateBellUI(lastUnreadCount);
        }
        if (e.key === STORAGE_TYPES_KEY) {
            lastUnreadByType = parseStoredTypes(e.newValue);
            updateSidebarBadges(lastUnreadByType);
        }
    });

    function parseStoredTypes(value) {
        try {
            return value ? JSON.parse(value) : {};
        } catch (e) {
            return {};
        }
    }

    function playNotificationSound() {
        if (!hasInteracted) return;
        notifSound.currentTime = 0;
        notifSound.play().catch(function () {});
    }

    function formatBadgeCount(count) {
        return count > 99 ? '99+' : String(count);
    }

    function requestNotificationPermission() {
        if ('Notification' in window && Notification.permission === 'default') {
            Notification.requestPermission();
        }
    }

    function showBrowserNotification(title, message) {
        if ('Notification' in window && Notification.permission === 'granted') {
            new Notification(title, { body: message, icon: '/images/logo.png' });
        }
    }

    function applyCounts(unreadCount, unreadByType) {
        lastUnreadCount = unreadCount || 0;
        lastUnreadByType = unreadByType || {};
        localStorage.setItem(STORAGE_KEY, lastUnreadCount);
        localStorage.setItem(STORAGE_TYPES_KEY, JSON.stringify(lastUnreadByType));
        updateBellUI(lastUnreadCount);
        updateSidebarBadges(lastUnreadByType);
    }

    function updateSidebarBadges(unreadByType) {
        Object.keys(SIDEBAR_BADGES).forEach(function (type) {
            var $el = SIDEBAR_BADGES[type];
            var count = unreadByType[type] || 0;
            if (count > 0) {
                $el.text(formatBadgeCount(count)).removeClass('d-none');
            } else {
                $el.text('').addClass('d-none');
            }
        });
    }

    function updateBellUI(count) {
        if (count > 0) {
            $headerSubtitle.text('You have ' + count + ' unread notification' + (count > 1 ? 's' : ''));
            $badge.removeClass('badge-dot badge-dot-sm').addClass('badge-pill').text(formatBadgeCount(count)).show();
            $bellIcon.removeClass('text-primary').addClass('text-danger');
            $bellBg.removeClass('bg-primary').addClass('bg-danger');
        } else {
            $headerSubtitle.text('You have no unread notifications');
            $badge.addClass('badge-dot badge-dot-sm').removeClass('badge-pill').text('').hide();
            $bellIcon.removeClass('text-danger').addClass('text-primary');
            $bellBg.removeClass('bg-danger').addClass('bg-primary');
        }
    }

    function renderNotificationList(notifications) {
        if (notifications.length === 0) {
            $container.html(
                '<div class="text-center mt-3 mb-3">' +
                    '<i class="fas fa-bell-slash fa-2x text-muted"></i>' +
                    '<p class="text-muted mt-2 mb-0">No notifications in the last 3 days</p>' +
                '</div>'
            );
            return;
        }

        var html = '<ul class="list-group list-group-flush">';
        notifications.forEach(function (n) {
            var isUnread = !n.read_at;
            var icon = getNotificationIcon(n.type);
            var data = n.data;
            var isCustom = isCustomNotification(n.type);
            var messageHtml = escapeHtml(data.message || '');
            if (isCustom) {
                var firstLine = (data.message || '').split(/\r?\n/)[0];
                messageHtml = firstLine ? beautify.excerpt(firstLine, 40) : '';
            }
            notificationsById[n.id] = n;

            html += '<li class="list-group-item notification-item ' + (isUnread ? 'unread' : '') + '" data-id="' + n.id + '" data-type="' + n.type + '" data-url="' + (data.url || '#') + '">';
            html += '<div class="d-flex align-items-start">';
            html += '<div class="mr-3 notification-icon ' + (isUnread ? 'text-primary' : 'text-muted') + '">';
            html += '<i class="fas ' + icon + '"></i>';
            html += '</div>';
            html += '<div class="flex-grow-1">';
            html += '<div class="d-flex justify-content-between">';
            html += '<strong class="notification-title">' + escapeHtml(data.title || n.type) + '</strong>';
            html += '<small class="text-muted">' + n.created_at + '</small>';
            html += '</div>';
            html += '<p class="mb-0 text-muted notification-message-text">' + messageHtml + '</p>';
            if (data.amount) {
                html += '<span class="badge badge-light mt-1">' + escapeHtml(formatCurrency(data.amount)) + '</span> ';
            }
            if (data.status) {
                html += '<span class="badge badge-' + getStatusBadge(data.status) + ' mt-1">' + escapeHtml(data.status) + '</span>';
            }
            html += '</div>';
            html += '</div>';
            html += '</li>';
        });
        html += '</ul>';
        html += '<div class="notification-footer">';
        html += '<button class="btn btn-sm btn-link mark-all-read">Mark all as read</button>';
        html += '<span class="notification-footer-separator">|</span>';
        html += '<button class="btn btn-sm btn-link text-danger delete-all-notifications">Delete all</button>';
        html += '</div>';

        $container.html(html);
        $container.find('[data-toggle="tooltip-light"]').tooltip({
            template: '<div class="tooltip tooltip-light"><div class="tooltip-inner"></div></div>'
        });
    }

    function isCustomNotification(type) {
        return type && String(type).indexOf('CustomNotification') !== -1;
    }

    function getNotificationIcon(type) {
        var icons = {
            'PayrollGenerated': 'fa-money-check-alt',
            'ClassReminder': 'fa-clock',
            'PasswordSetup': 'fa-key',
            'TestNotification': 'fa-flask',
            'InvoiceGenerated': 'fa-file-invoice-dollar',
            'InvoiceMarkedPaid': 'fa-file-invoice-dollar',
            'InvoiceDeleted': 'fa-trash',
            'PayrollDeleted': 'fa-trash',
            'InvoicesGeneratedSummary': 'fa-file-invoice',
            'PayrollsGeneratedSummary': 'fa-money-check-alt',
            'IntakeRegistrationSubmitted': 'fa-user-plus',
        };
        return icons[type] || 'fa-bell';
    }

    function getStatusBadge(status) {
        var badges = {
            'draft': 'warning',
            'pending': 'info',
            'approved': 'info',
            'paid': 'success',
            'unpaid': 'danger',
            'partially_paid': 'warning',
            'rejected': 'danger',
        };
        return badges[status.toLowerCase()] || 'secondary';
    }

    function formatCurrency(amount) {
        return parseFloat(amount).toFixed(2);
    }

    function escapeHtml(text) {
        if (!text) return '';
        var div = document.createElement('div');
        div.appendChild(document.createTextNode(text));
        return div.innerHTML;
    }

    function fetchNotifications(opts) {
        var silent = opts && opts.silent;
        var forceRender = opts && opts.forceRender;

        $.ajax({
            url: window.notificationsUrl,
            method: 'GET',
            headers: { 'X-CSRF-TOKEN': $('meta[name=csrf-token]').attr('content') },
            success: function (res) {
                if (res.status !== 'success') return;

                var newJson = JSON.stringify(res.data);
                var unreadByType = res.unread_by_type || {};
                var changed = res.unread_count !== lastUnreadCount || newJson !== lastNotificationsJson;
                var prevStoredCount = lastUnreadCount;

                lastNotificationsJson = newJson;
                applyCounts(res.unread_count, unreadByType);

                if (changed || forceRender) {
                    renderNotificationList(res.data);

                    if (!silent && res.unread_count > prevStoredCount) {
                        playNotificationSound();
                        if (res.data.length > 0) {
                            var latest = res.data[0];
                            showBrowserNotification(
                                escapeHtml(latest.data.title || latest.type),
                                escapeHtml(latest.data.message || '')
                            );
                        }
                    }
                }

                autoOpenCustomNotification(res.data);
            },
        });
    }

    function autoOpenCustomNotification(notifications) {
        if ($customModal.hasClass('show')) return;
        for (var i = 0; i < notifications.length; i++) {
            var n = notifications[i];
            if (!n.read_at && isCustomNotification(n.type) && !shownCustomIds[n.id]) {
                shownCustomIds[n.id] = true;
                showCustomNotification(n);
                break;
            }
        }
    }

    function markAsRead(id) {
        $.ajax({
            url: window.notificationsReadUrl.replace('__ID__', id),
            method: 'POST',
            headers: { 'X-CSRF-TOKEN': $('meta[name=csrf-token]').attr('content') },
            success: function (res) {
                if (res.status === 'success') {
                    $container.find('[data-id="' + id + '"]').removeClass('unread')
                        .find('.notification-icon').removeClass('text-primary').addClass('text-muted');
                    applyCounts(res.unread_count, res.unread_by_type);
                }
            },
        });
    }

    function markAllAsRead() {
        $.ajax({
            url: window.notificationsReadAllUrl,
            method: 'POST',
            headers: { 'X-CSRF-TOKEN': $('meta[name=csrf-token]').attr('content') },
            success: function (res) {
                if (res.status === 'success') {
                    $container.find('.notification-item').removeClass('unread');
                    $container.find('.notification-icon').removeClass('text-primary').addClass('text-muted');
                    applyCounts(0, {});
                }
            },
        });
    }

    function deleteAllNotifications() {
        $.ajax({
            url: window.notificationsDeleteAllUrl,
            method: 'POST',
            headers: { 'X-CSRF-TOKEN': $('meta[name=csrf-token]').attr('content') },
            success: function (res) {
                if (res.status === 'success') {
                    notificationsById = {};
                    lastNotificationsJson = '[]';
                    applyCounts(0, {});
                    renderNotificationList([]);
                }
            },
        });
    }

    function confirmDeleteAllNotifications() {
        if (typeof beautify !== 'undefined' && beautify.sweetConfirm) {
            beautify.sweetConfirm('Delete all notifications?', 'This will permanently remove all your notifications.', function (confirmed) {
                if (confirmed) deleteAllNotifications();
            });
        } else if (confirm('Delete all notifications?')) {
            deleteAllNotifications();
        }
    }

    var $customModal = $('#customNotificationModal');
    var customModalShownId = null;

    function showCustomNotification(notif) {
        customModalShownId = notif.id;
        $('#customNotificationTitle').text(notif.data.title || 'Notification');
        var message = escapeHtml(notif.data.message || '').replace(/\n/g, '<br>');
        $('#customNotificationBody').html('<p class="mb-0">' + message + '</p>');
        $customModal.modal('show');
    }

    $(document).on('click', '#customNotificationOk', function () {
        var id = customModalShownId;
        $customModal.modal('hide');
        customModalShownId = null;

        if (id) {
            markAsRead(id);
            fetchNotifications({ forceRender: true });
        }
    });

    $bell.on('click', function () {
        fetchNotifications({ forceRender: true });
    });

    $(document).on('click', '.notification-item', function () {
        var $item = $(this);
        var id = $item.data('id');
        var type = $item.data('type');
        var url = $item.data('url');

        if (type && String(type).indexOf('CustomNotification') !== -1) {
            var selectedNotification = notificationsById[id];
            showCustomNotification(selectedNotification || {
                id: id,
                data: {
                    title: $item.find('.notification-title').text(),
                    message: $item.find('.notification-message-text').text(),
                },
            });
            return;
        }

        markAsRead(id);
        if (url && url !== '#') {
            window.location.href = url;
        }
    });

    $(document).on('click', '.mark-all-read', function (e) {
        e.stopPropagation();
        markAllAsRead();
    });

    $(document).on('click', '.delete-all-notifications', function (e) {
        e.stopPropagation();
        confirmDeleteAllNotifications();
    });

    setInterval(function () { fetchNotifications(); }, 25000);
    fetchNotifications({ silent: true });
});
